import { Dashboard } from 'types/dashboards';

import { env } from '../../env';
import { Service } from '../service';
import { GetDashboardDTO } from './dto/analytics.dto';

let instance: AnalyticServiceClass;

class AnalyticServiceClass extends Service {
  constructor() {
    if (instance) {
      console.log('singleton pattern, will not create the same instance twice');

      return instance;
    }

    super(env.VITE_ANALYTICS_API_URL);
    instance = this;
  }

  async getDashboards(): Promise<GetDashboardDTO> {
    const allDashboard = (await this.get('/dashboards')) as Dashboard[];

    if (allDashboard.length == 0) {
      return {
        dashboards: [],
        embed: undefined
      };
    }

    let firstEmbed = undefined;
    if (allDashboard.length > 0) {
      firstEmbed = await this.get(`/dashboards/${allDashboard[0].id}/embed`);
    }

    return {
      dashboards: allDashboard,
      // STMN-3697 / P5 -- was `firstEmbed.link`. When the embed reply came back without a
      // body this raised "Cannot read properties of undefined (reading 'link')", and
      // DashboardContext then reported its generic message: a second route by which the
      // real fault was replaced with an unrelated one. A missing embed is not a crash --
      // the dashboard list is still worth showing.
      embed: firstEmbed?.link
    };
  }

  async getEmbed(id: string): Promise<string> {
    const embed = await this.get(`/dashboards/${id}/embed`);
    return embed.link;
  }
}

const AnalyticsService = Object.freeze(new AnalyticServiceClass());

export default AnalyticsService;
